export { LegendComponent } from './legend.component';
export * from './types';
